import { useContext } from 'react';
import useScript from '../../hooks/useScript';
import ConfigContext from '../../contexts/ConfigContext';

const configBoomerang = (boomerangBeaconUrl) => {
  window.BOOMR.init({
    autorun: false,
    beacon_type: "POST",
    instrument_xhr: true,
    Errors: {
        enabled: true,
        sendAfterOnload: true
    },
    beacon_url: boomerangBeaconUrl,
    clicks: {
        click_url: boomerangBeaconUrl,
        track_spa_clicks: true
    },
    Continuity: {
        enabled: true,
        afterOnload: true,
        waitAfterOnload: 1000,
        monitorStats: false,
        monitorInteractions: false
    },
    History: {
        enabled: true,
        auto: true
    },
    log: function() { },
    applicationInfo: {
        getAppId: function getAppId() {
          return "public_pages";
        },
        getServerName: function getServerName() {
          return window.Dell.Metrics.sc.server;
        },
        getUserObj: function getUserObj() {
          return window.Dell.Metrics.sc;
        }
    }
  })
};

const Boomerang = () => {
  const { BOOMERANG_URL, BOOMERANG_BEACON_URL } = useContext(ConfigContext);

  useScript(
    BOOMERANG_URL,
     () => BOOMERANG_BEACON_URL && configBoomerang(BOOMERANG_BEACON_URL)
  );

  return null;
};

export default Boomerang;
